class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.addEventListener('change', this.onVariantChange);

    this.currentVariant = this.getVariantData().find(variant => variant.id == this.select.value);

    setTimeout(() => {
      this.updateMedia();
    }, 100);
  }

  onVariantChange(e) {
    this.currentVariant = this.getVariantData().find(variant => variant.id == this.select.value);

    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateURL();
    this.renderProductInfo();
    this.updateMedia();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.updateShareUrl();
    }
  }

  updateMedia() {
    const sectionId = this.dataset.section;
    const mediaGridySlider = document.getElementById(`slider-${sectionId}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${sectionId}`);

    if (!mediaGridySlider) return;

    if (!this.currentVariant) {
      mediaGridySlider.removeAttribute('data-init-scroll-to');
      mediaGridySlider.querySelectorAll('.product-media').forEach((item, index) => {
        item.style.display = 'block';

        const indicator = mediaGridySlider.querySelector('.gridy-indicator .indicator--dots').children[index];
        if (indicator) {
          indicator.style.display = 'block';
        }
      });

      mediaGridySlider.reset();

      return;
    }

    if (
      mediaGridySlider.getAttribute('data-is-furniture') === 'false' ||
      parseInt(mediaGridySlider.getAttribute('data-variant-count')) === 1
    )
      return;

    const featuredMediaId = this.currentVariant.featured_media?.id;
    const variantId = this.currentVariant.id;

    mediaGridySlider.querySelectorAll('.product-media').forEach((item, index) => {
      const mediaId = parseInt(item.getAttribute('data-media-id'));
      const isFeaturedMedia = mediaId === featuredMediaId;
      const isVariantMedia =
        item.hasAttribute('data-variant-id') && parseInt(item.getAttribute('data-variant-id')) === variantId;
      item.style.display = isFeaturedMedia || isVariantMedia ? 'block' : 'none';

      const indicator = mediaGridySlider.querySelector('.gridy-indicator .indicator--dots').children[index];
      if (indicator) {
        indicator.style.display = isFeaturedMedia || isVariantMedia ? 'block' : 'none';
      }
    });

    mediaGridySlider.reset(false);

    if (featuredMediaId) {
      mediaGridySlider.scrollToSlideByID(`item-${featuredMediaId}`);
    }

    if (thumbnailsGridySlider && featuredMediaId) {
      thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${featuredMediaId}`);
    }
  }

  updateURL() {
    // Check if the updateUrl data attribute is set to 'false'
    if (this.dataset.updateUrl === 'false') return;

    // Ensure the dataset and currentVariant have the required values
    const url = this.dataset.url;
    const variantId = this.currentVariant?.id;

    // Construct and update the URL with the variant parameter
    if (url && variantId) {
      const newUrl = `${url}?variant=${variantId}`;
      window.history.replaceState({}, '', newUrl);
    } else {
      window.history.replaceState({}, '', url);
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`,
    );
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      variant => this.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (
        variantInventoryObject.quantity <= 0 &&
        variantInventoryObject.incoming === 'true' &&
        variantInventoryObject.quantity < this.inventoryThreshold
      ) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    this.productInventoryNode.classList.remove(
      'inventory-status--in-stock',
      'inventory-status--low',
      'inventory-status--sold-out',
      'inventory-status--sold-out-continue-selling',
    );

    if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) <= parseInt(this.inventoryThreshold) &&
      parseInt(quantity) > 0
    ) {
      this.productInventoryNode.classList.add('inventory-status--low');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
    } else if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) > parseInt(this.inventoryThreshold)
    ) {
      this.productInventoryNode.classList.add('inventory-status--in-stock');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) < 1) {
      this.productInventoryNode.classList.add('inventory-status--sold-out-continue-selling');
      this.productInventoryNode.firstElementChild.textContent =
        window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove('hide');
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date
      ? window.variantStrings.inventory.waiting_for_stock
      : window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}${this.currentVariant?.id ? `?variant=${this.currentVariant.id}&` : '?'}section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`,
    )
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const destinationBuyBarInfo = document.getElementById(`buy-bar-info-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const buyBarInfoSource = html.getElementById(
          `buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo) destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(
          !this.currentVariant?.available,
          this.currentVariant ? window.variantStrings.soldOut : window.variantStrings.addToCart,
        );

        // Dynamic content based on metafields
        const newProductDetails = Array.from(html.querySelectorAll('[data-product-dynamic-content]'));

        document.querySelectorAll('[data-product-dynamic-content]').forEach(currentItem => {
          const contentId = currentItem.getAttribute('data-product-dynamic-content');

          const newContentItem = newProductDetails.find(
            newDetail => newDetail.getAttribute('data-product-dynamic-content') === contentId,
          );

          if (newContentItem) {
            currentItem.innerHTML = newContentItem.innerHTML;
          }
        });

        // Delivery date
        const deliveryTimeElement = this.querySelector('[data-delivery-time]');

        if (deliveryTimeElement) {
          if (this.currentVariant && this.currentVariant.delivery_time) {
            if (this.currentVariant.is_custom_rug) {
              deliveryTimeElement.classList.add('hidden');
            } else {
              deliveryTimeElement.classList.remove('hidden');
            }

            deliveryTimeElement.querySelector('[data-delivery-time-value]').textContent =
              this.currentVariant.delivery_time;
            deliveryTimeElement.querySelector('input').value = this.currentVariant.delivery_time;
            deliveryTimeElement.querySelector('input').disabled = false;
          } else {
            deliveryTimeElement.classList.add('hidden');
            deliveryTimeElement.querySelector('input').disabled = true;
          }
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const multiplyButtons = productForm.querySelectorAll('.btn--add-multiplier');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.disabled = true;
        });
      }
    } else {
      addButton.removeAttribute('disabled');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.removeAttribute('disabled');
        });
      }
    }

    const productForm_BuyBar = document.getElementById(`product-form-${this.dataset.section}-product-buy-bar`);
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector('[name="add"] > span');

      if (disable) {
        addButton_BuyBar.setAttribute('disabled', 'disabled');
        if (text) addButtonText_BuyBar.textContent = text;
      } else {
        addButton_BuyBar.removeAttribute('disabled');
        if (this.dataset.isPreorder == 'true') {
          addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.addToCart;
    if (price) price.classList.add('hidden');

    const button_BuyBar = document.getElementById(`product-form-${this.dataset.section}-product-buy-bar`);
    const addButton_BuyBar = button_BuyBar?.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar?.querySelector('[name="add"] > span');
    const price_BuyBar = document.getElementById(`price-${this.dataset.section}-product-buy-bar`);
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
    if (price_BuyBar) price_BuyBar.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-picker', VariantPicker);

class ProductBuyBar extends HTMLElement {
  constructor() {
    'use strict';
    super();

    let classes = { show: 'show' };
    let mainProductForm = document.querySelector('.product-form');

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 },
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener('DOMContentLoaded', function () {
      let siteFooter = document.querySelector('footer.footer');
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define('product-buy-bar', ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', event => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) {
          this.updateImage(newImgSrc);
        }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);

class ReadMoreElement extends HTMLElement {
  constructor() {
    super();
    // Bind the toggle method to the element's context
    this.toggle = this.toggle.bind(this);
  }

  connectedCallback() {
    // Use the stored selectors to add event listeners
    //this.addEventListener('click', this.toggle);
    const moreBtn = this.querySelector('[data-btn="more"]');
    const lessBtn = this.querySelector('[data-btn="less"]');
    if (moreBtn) moreBtn.addEventListener('click', this.toggle);
    if (lessBtn) lessBtn.addEventListener('click', this.toggle);
  }

  toggle(event) {
    //event.preventDefault();
    // Use the stored selectors for DOM manipulation

  if (
    event.target.matches('[data-btn="more"]') ||
    event.target.matches('[data-btn="less"]') 
  ) {
    event.preventDefault();

    this.classList.toggle('expanded');
    const content = this.querySelector('.read-more-content');
    const moreBtn = this.querySelector('[data-btn="more"]');
    const lessBtn = this.querySelector('[data-btn="less"]');
    if (content) {
      content.classList.toggle('hidden');
    }
    if (moreBtn && lessBtn) {
      moreBtn.classList.toggle('hidden');
      lessBtn.classList.toggle('hidden');
    }
  }
}
}

// Define the custom element if not already
if (!window.customElements.get('read-more')) {
  customElements.define('read-more', ReadMoreElement);
}



// Set pdp-content height as CSS variable for media-sliders
document.addEventListener('DOMContentLoaded', () => {
  const pdpContent = document.querySelector('.pdp-content');
  const pdpMedia = document.querySelector('.pdp-media');
  console.log('pdpContent:', pdpContent);
  console.log('pdpMedia:', pdpMedia);
  if (!pdpContent || !pdpMedia) return;
  
  function updateMediaHeight() {
    const contentHeight = pdpContent.offsetHeight;
    pdpMedia.style.setProperty('--pdp-content-height', `${contentHeight}px`);
  }
  
  // Update on load
  updateMediaHeight();
  
  // Update on window resize
  window.addEventListener('resize', updateMediaHeight);
  
  // Update when content changes (using ResizeObserver for better performance)
  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(updateMediaHeight);
    resizeObserver.observe(pdpContent);
  }

  // Desktop only scroll behavior
  if (window.innerWidth < 1024) return;

  const mediaSliders = pdpMedia.querySelector('.media-sliders');
  if (!mediaSliders) return;

  let isOverMedia = false;
  let contentScrollPhase = 'content'; // 'content', 'media', 'page'
  let lastScrollDirection = 0;

  // Track mouse position over media
  pdpMedia.addEventListener('mouseenter', () => {
    isOverMedia = true;
  });

  pdpMedia.addEventListener('mouseleave', () => {
    isOverMedia = false;
  });

  // Check if pdp-content is scrolled to bottom minus one image height
  function isContentNearEnd() {
    const contentRect = pdpContent.getBoundingClientRect();
    const contentBottom = contentRect.bottom;
    const windowHeight = window.innerHeight;
    
    // Get the height of one image slide
    const firstImage = mediaSliders.querySelector('.product-media');
    const imageHeight = firstImage ? firstImage.offsetHeight : 0;
    const windowScrollY = window.scrollY;

    // Check if content bottom is at viewport bottom minus one image height
    /*const contentHeight = pdpContent.offsetHeight;
    console.log('windowScrollY:', windowScrollY);
    //const triggerPoint = windowHeight + imageHeight;
    const triggerPoint = contentHeight - imageHeight
    console.log('contentBottom:', contentBottom, 'triggerPoint:', triggerPoint, 'windowScrollY:', windowScrollY);
    return contentBottom <= triggerPoint;*/
        // Get the height of one image slide

    // Calculate trigger point: content height minus one image height
    const contentHeight = pdpContent.offsetHeight;
    const triggerPoint = contentHeight - imageHeight;
    
    //console.log('windowScrollY:', windowScrollY, 'triggerPoint:', triggerPoint, 'imageHeight:', imageHeight);
    
    // Trigger when we've scrolled past the trigger point
    return windowScrollY >= triggerPoint;

  }

  // Check if media is scrolled to the last slide
  function isMediaAtEnd() {
    const isAtBottom = mediaSliders.scrollTop + mediaSliders.clientHeight >= mediaSliders.scrollHeight - 1;
    return isAtBottom;
  }

    // Handle wheel events
  window.addEventListener('wheel', (e) => {
    // Only apply on desktop
    if (window.innerWidth < 1024) return;
    
    // If mouse is over media, let it scroll normally
    if (isOverMedia) return;

    const scrollingDown = e.deltaY > 0;
    const scrollingUp = e.deltaY < 0;

    // Update scroll direction
    if (scrollingDown) lastScrollDirection = 1;
    if (scrollingUp) lastScrollDirection = -1;

    // Special case: If page is at top and scrolling up, scroll media up
    const isPageAtTop = window.scrollY <= 10;
    const mediaHasScrollUp = mediaSliders.scrollTop > 0;
    const mediaAtTop = mediaSliders.scrollTop <= 0;
    
    if (scrollingUp && isPageAtTop && mediaHasScrollUp) {
      e.preventDefault();
      mediaSliders.scrollTop += e.deltaY;
      return;
    }

    // If at top and media is also at top, ensure we're in content phase
    if (isPageAtTop && mediaAtTop) {
      contentScrollPhase = 'content';
    }

    // PHASE 1: Scrolling content
    if (contentScrollPhase === 'content') {
      // Check if we're approaching or at the trigger point
      const firstImage = mediaSliders.querySelector('.product-media');
      const imageHeight = firstImage ? firstImage.offsetHeight : 0;
      const contentHeight = pdpContent.offsetHeight;
      const triggerPoint = contentHeight - imageHeight;
      
      if (scrollingDown) {
        // If we're at or past trigger point, switch to media phase and prevent further page scroll
        if (window.scrollY >= triggerPoint) {
          e.preventDefault();
          contentScrollPhase = 'media';
          mediaSliders.scrollTop += e.deltaY;
          return;
        }
        
        // If this scroll would take us past the trigger point, clamp it
        const maxScroll = triggerPoint;
        if (window.scrollY + e.deltaY > maxScroll) {
          e.preventDefault();
          window.scrollTo(0, maxScroll);
          contentScrollPhase = 'media';
          return;
        }
      }
      // Allow normal page scroll
      return;
    }

    // PHASE 2: Scrolling media
    if (contentScrollPhase === 'media') {
      if (scrollingUp) {
        // Check if media is at top
        if (mediaAtTop) {
          // Media is at top, return to content phase and allow page scroll
          contentScrollPhase = 'content';
          return;
        }
        
        // Media still has content to scroll up, intercept and scroll media
        e.preventDefault();
        mediaSliders.scrollTop += e.deltaY;
        return;
      }

      if (scrollingDown) {
        // Check if media is at end
        if (isMediaAtEnd()) {
          // Transition to normal page scroll
          contentScrollPhase = 'page';
          return;
        }

        // Intercept scroll and apply to media
        e.preventDefault();
        mediaSliders.scrollTop += e.deltaY;
      }
      return;
    }

    // PHASE 3: Normal page scrolling (after media is done)
    if (contentScrollPhase === 'page') {
      if (scrollingUp && !isContentNearEnd()) {
        // If user scrolls back up past the trigger point, reset to content phase
        contentScrollPhase = 'content';
      }
      // Allow normal page scroll
      return;
    }
  }, { passive: false });

  // Monitor page scroll to update phase
  window.addEventListener('scroll', () => {
    if (window.innerWidth < 1024) return;
    
    // If content is no longer near end and we're in media/page phase, reset
    if ((contentScrollPhase === 'media' || contentScrollPhase === 'page') && !isContentNearEnd()) {
      contentScrollPhase = 'content';
    }
  });
});
